import React from 'react';
import {
  Typography,
  Box,
  Divider,
} from '@mui/material';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import { WidgetContainer } from '../../widgets.styles';

// Mock data - will be replaced with real streak tracking
const streakData = {
  currentStreak: 12,
  longestStreak: 28,
  message: "You're on fire! Keep it going!",
};

/**
 * Returns a motivational message based on streak count.
 */
const getStreakMessage = (count) => {
  if (count === 0) return 'Start your streak today!';
  if (count < 3) return 'Great start! Keep building momentum.';
  if (count < 7) return 'Nice consistency! One week is within reach.';
  if (count < 14) return "You're on fire! Keep it going!";
  if (count < 30) return 'Incredible dedication! A month is next.';
  return 'Legendary streak! You are unstoppable!';
};

/**
 * Active Streak widget - displays current workout streak with flame icon.
 * Uses mock data for now.
 */
const ActiveStreak = () => {
  const { currentStreak, longestStreak } = streakData;
  const message = getStreakMessage(currentStreak);

  return (
    <WidgetContainer>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          p: 2.5,
        }}
      >
        {/* Flame icon with gradient background */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 48,
            height: 48,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #F97316 0%, #EF4444 100%)',
            flexShrink: 0,
          }}
        >
          <LocalFireDepartmentIcon sx={{ color: '#FFFFFF', fontSize: 28 }} />
        </Box>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5 }}>
            <Typography variant="h4" sx={{ fontWeight: 800, lineHeight: 1 }}>
              {currentStreak}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
              day streak
            </Typography>
          </Box>
          <Typography variant="caption" color="text.secondary">
            {message}
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          px: 2.5,
          py: 1.5,
        }}
      >
        <Typography variant="caption" color="text.secondary">
          Longest streak
        </Typography>
        <Typography variant="caption" sx={{ fontWeight: 700 }}>
          {longestStreak} days
        </Typography>
      </Box>
    </WidgetContainer>
  );
};

export default ActiveStreak;
